import { render, staticRenderFns } from "./StampCollections.vue?vue&type=template&id=c111882e&scoped=true&lang=pug&"
import script from "./StampCollections.vue?vue&type=script&lang=js&"
export * from "./StampCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c111882e",
  null
  
)

export default component.exports